import {ChartData} from '../../../doughnut/doughnut.component';
import {XirrCalculator} from '../../../service/xirr-calculator';
import {ChartDataUtil} from '../../../doughnut/chart-data.util';
import {GaugedInvestment} from '../../../model/gauged-investment.model';
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-auto-invest-header',
    templateUrl: 'auto-invest-header.component.html',
    styleUrls: ['../../../../assets/styles/finzy-styles.scss']
})
export class AutoInvestHeaderComponent implements OnChanges {
    @Input()
    public gaugedInvestments: GaugedInvestment[];
    public expectedRoi: number;
    public chartData: ChartData[] = [];
    private readonly xirrCalculator: XirrCalculator;
    private readonly chartDataUtil: ChartDataUtil;

    constructor(xirrCalculator: XirrCalculator, chartDataUtil: ChartDataUtil) {
        this.xirrCalculator = xirrCalculator;
        this.chartDataUtil = chartDataUtil;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.gaugedInvestments && changes.gaugedInvestments.currentValue) {
            this.onGaugedInvestmentsReceived(changes.gaugedInvestments.currentValue);
        }
    }

    async onGaugedInvestmentsReceived(gaugedInvestments: GaugedInvestment[]) {
        const investments = gaugedInvestments.map(gaugedInvestment => ({
            investmentAmount: gaugedInvestment.amount,
            roi: gaugedInvestment.loan.roi,
            tenure: gaugedInvestment.loan.loan_tenure
        }));
        this.expectedRoi = await this.xirrCalculator.calculateForInvestments(investments);
        this.chartData = this.chartDataUtil.convertToChartDataForInvestments(gaugedInvestments.map(gaugedInvestment => ({
            amount: gaugedInvestment.amount,
            rating: gaugedInvestment.loan.rating
        })));
    }
}